import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
export const parkingTypeApi = createApi({
  reducerPath: 'parkingTypeApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingType'],
  endpoints: builder => ({
    getParkingTypeData: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingTypeController.getParkingTypeData,
          method: 'POST',
          headers: body.token ?{ Authorization: `Bearer ${body.token}` }:{},
          body: body.payload,
        };
      },
    }),
  }),
});


export const { useGetParkingTypeDataMutation } = parkingTypeApi;
